import { TableBody as FBTableBody } from "flowbite-react";

const TableBody = (props) => {
  return <FBTableBody {...props}>{props.children}</FBTableBody>;
};

export default TableBody;